import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ palette: theme }: Theme) =>
  createStyles({
    buttonDownload: {
      margin: '16px 0 0',
    },

    switchContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 8,
    },
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    switchLabel: {
      fontSize: 14,
    },

    checkboxCell: {
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },

    tableCellSize: {
      width: 96,
      color: palette.darkGray,
      fontSize: 14,
    },

    wrapStatus: {
      paddingLeft: 26,
      gap: 8,
      alignItems: 'center',
      fontSize: 12,
    },
    center: {
      justifyContent: 'center',
      paddingLeft: 26,
      fontSize: 12,
      color: palette.darkGray,
    },
    centerConfig: {
      paddingLeft: 50,
      fontSize: 12,
      color: palette.darkGray,
    },

    iconFormat: {
      background: palette.deepBlue,
      color: palette.white,
      borderRadius: '50%',
      padding: 6,
      transform: 'scale(.7)',
    },

    selectFile: {
      display: 'flex',
      alignItems: 'center',
      padding: 8,
      margin: 8,
      border: `1px solid ${theme.grey[300]}`,
      borderRadius: 4,
      height: 56,

      '& .MuiButton-root': {
        marginRight: 8,
      },
    },
    buttons: {
      margin: '40px auto',
      paddingBottom: 24,

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },
    header: {
      fontSize: 12,
      color: palette.darkGray,
    },
    saltLabel: {
      fontSize: 14,
      color: palette.darkGray,
      fontWeight: 500,
      padding: '0 15px',
    },
    saltGrid: {
      paddingTop: 10,
      paddingLeft: 8,
      justifyContent: 'center',

      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
      },

      '& .MuiOutlinedInput-adornedEnd': {
        padding: 0,
      },
    },
    formUser: {
      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    buttonsHeader: {
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      alignItems: 'center',
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '13px 20px',
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      padding: '10px 0px 5px 0px',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
    },
    templateText: {
      fontSize: 14,
      fontWeight: 500,
      color: palette.blue,
    },
    dateField: {
      color: palette.darkGray,
      whiteSpace: 'nowrap',
    },
    tableContainer: {
      marginTop: 32,
    },
    warningIcon: {
      color: palette.yellow,
      fontSize: 12,
      marginLeft: 4,
      cursor: 'pointer',
    },
    reasonField: {
      '& .MuiOutlinedInput-root': { height: 'auto' },
      '& .MuiOutlinedInput-multiline': { padding: 14 },
    },
    buttonsBypassActions: { margin: '8px 0px' },
    radioGroupFields: {
      '& div': {
        justifyContent: 'space-between',
      },
    },
  });
